"use client";

import React from "react";
import { Flower2, Sparkles, Clock, HeartHandshake, ShieldCheck, Zap } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const benefits = [{
  title: "Expert Clinical Care",
  description: "Our medical professionals provide elite IV therapy with clinical precision and a personalized touch for your wellness journey.",
  icon: ShieldCheck
}, {
  title: "Luxurious Lounge",
  description: "Experience rejuvenation in a high-end environment designed for ultimate relaxation and sensory indulgence.",
  icon: Sparkles
}, {
  title: "Rapid Recovery",
  description: "Our hydration treatments deliver essential nutrients directly to your system for immediate and lasting energy boosts.",
  icon: Zap
}, {
  title: "Bespoke Wellness",
  description: "Every treatment plan is tailored to your specific health goals, from skin vitality to immune system support.",
  icon: HeartHandshake
}];
export default function WhyChooseUs() {
  const headerReveal = useRevealOnScroll({
    threshold: 0.1
  });
  const gridReveal = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="221522" id="the-al-shifa-advantage" className="relative py-24 md:py-32 px-4 sm:px-6 lg:px-8 overflow-hidden bg-background">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-primary/5 rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-chart-2/5 rounded-full blur-3xl" />
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div ref={headerReveal.ref} className={`text-center max-w-3xl mx-auto mb-20 transition-all duration-1000 ease-out ${headerReveal.isVisible ? "opacity-100 translate-y-0 blur-0" : "opacity-0 translate-y-12 blur-sm"}`}>
          <span className="text-primary font-sans font-bold tracking-[0.2em] uppercase text-sm mb-4 block">
            The Al Shifa Standard
          </span>
          <h2 className="font-serif text-4xl md:text-6xl font-bold mb-8 tracking-tight text-foreground">
            The Al Shifa Advantage
          </h2>
          <div className="w-24 h-1 bg-primary/30 mx-auto mb-8" />
          <p className="text-muted-foreground text-lg md:text-xl font-sans font-light leading-relaxed">
            Elevate your health with our premium hydration services. Discover the elite 
            standards that define the Al Shifa experience in St Cloud, where clinical 
            excellence meets unparalleled luxury.
          </p>
        </div>

        <div ref={gridReveal.ref} className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 transition-all duration-1000 delay-300 ease-out ${gridReveal.isVisible ? "opacity-100 translate-y-0 blur-0" : "opacity-0 translate-y-16 blur-sm"}`}>
          {benefits.map((benefit, i) => {
          const Icon = benefit.icon;
          return <Card key={i} data-index={i} className="bg-card/40 backdrop-blur-xl border border-primary/20 hover:border-primary/50 transition-all duration-500 shadow-xl hover:shadow-primary/10 group relative overflow-hidden">
                <CardHeader className="pb-4 relative z-10">
                  <div className="w-14 h-14 rounded-xl bg-primary/10 flex items-center justify-center mb-6 group-hover:scale-110 group-hover:bg-primary/20 transition-all duration-500">
                    <Icon className="w-7 h-7 text-primary" strokeWidth={1.5} />
                  </div>
                  <CardTitle className="font-serif text-2xl tracking-tight text-foreground group-hover:text-primary transition-colors duration-300">
                    {benefit.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="relative z-10">
                  <p className="text-muted-foreground text-base font-sans leading-relaxed">
                    {benefit.description}
                  </p>
                </CardContent>
                {}
                <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-primary/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              </Card>;
        })}
        </div>

        {}
        <div className="mt-24 rounded-2xl overflow-hidden relative h-[400px] group">
          <img src="https://shifahydrationlounge.com/wp-content/uploads/2026/05/3T4A1613-scaled.jpg" alt="Al Shifa Luxury Lounge" className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1661213/img/luxury_lounge_interior.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1661213/img/luxury_lounge_interior.png-wvc-sizes" loading="lazy" />
          <div className="absolute inset-0 bg-gradient-to-t from-background via-background/20 to-transparent" />
          <div className="absolute bottom-8 left-8 right-8 text-center md:text-left">
            <p className="font-serif text-2xl italic !text-[rgba(0,0,0,1)] md:text-3xl">
              "A sanctuary of wellness in the heart of St Cloud."
            </p>
          </div>
        </div>
      </div>
    </section>;
}